import { post,get,postJson,postLogin} from './axios'

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/login'
const RESOURCE_BASE_PATH = '/login'


// export const login = p => postLogin(`${RESOURCE_BASE_PATH}/testLogin`, p);
export const login = p => get(`/login/test`, p);


///login/log-out
export const logout = p => post(`${RESOURCE_BASE_PATH}/log-out`, p);


// export const cutHostToSonShop = p => post(`${RESOURCE_BASE_PATH}/cutHostToSonShop`, p);

// export const loginTimeout = p => get(`${RESOURCE_BASE_PATH}/loginTimeout`, p);

// // 全渠道登楼接口
// export const allChannelLogin = p => get(`${RESOURCE_BASE_PATH}/allChannelLogin`, p);


// 授权码登录
export const loginAuthCode = p => post(`/login/auth-code/${p}`);

// 获取短信验证码
export const loginSendCode = p => get(`/login/send-code`, p);

// 短信验证码登录
export const loginSmsCode = p => postJson(`/login/sms-code`, p);